export const SmartCollectionErrorCodes = {
    NotLicensed: "SmartCollection_NotLicensed",
    RecordNotFound: "SmartCollection_RecordNotFound",
    Unknown: "SmartCollection_UnknownError"
}